/*
 * MathGraph32 Javascript : Software for animating online dynamic mathematics figures
 * http://www.mathgraph32.org/
 * @Author Yves Biton (yves.biton@sesamath.net)
 * @License: GNU AGPLv3 https://www.gnu.org/licenses/agpl-3.0.html
 */

const NatCal = require('../types/NatCal')
const CFonc = require('./CFonc')
const CConstante = require('./CConstante')
const COp = require('./COperation')
const Ope = require('../types/Ope')
const CalcR = require('../kernel/CalcR')
module.exports = CDerivee

/**
 * Classe représentant une fonction qui est la dérivée d'un fonction utilisateur
 * à une variable définie par l'utilisateur.
 * Elle est calculée de façon formelle (mais non simplifiée).
 * @constructor
 * @extends CFonc
 * @param {CListeObjets} listeProprietaire : La liste propriétaire de l'objet.
 * @param {CImplementationProto} impProto : null ou la construction propriétaire de l'objet.
 * @param {Boolean} estElementFinal : true si l'objet est un objet final de construction
 * @param {String} nomCalcul : Le nom de la fonction dérivée.
 * @param {CFonc} fonctionAssociee : La fonction dont c'est la dérivée.
 * @param {CCb} calcul : un calcul donnant la dérivée (peut être null).
 * @returns {CDerivee}
 */
function CDerivee (listeProprietaire, impProto, estElementFinal, nomCalcul,
  fonctionAssociee, calcul) {
  var calc;
  if (arguments.length === 1) CFonc.call(this, listeProprietaire);
  else {
    if (arguments.length === 5) calc = null; else calc = calcul;
    CFonc.call(this, listeProprietaire, impProto, estElementFinal, nomCalcul, "", calc);
    this.fonctionAssociee = fonctionAssociee;
    if ((calc === null) && (fonctionAssociee !== null)) this.creeCalcul();
  }
}
CDerivee.prototype = new CFonc();
CDerivee.prototype.constructor = CDerivee;
CDerivee.prototype.superClass = "CFonc";
CDerivee.prototype.className = "CDerivee";

CDerivee.prototype.getClone = function(listeSource, listeCible) {
  var ind1 = listeSource.indexOf(this.impProto);
  var ind2 = listeSource.indexOf(this.fonctionAssociee);
  var ptelb = new CDerivee(listeCible, listeCible.get(ind1, "CImplementationProto"),
    this.estElementFinal, this.nomCalcul, listeCible.get(ind2, "CFonc"), null);
  if (listeCible.className !== "CPrototype") ptelb.creeCalcul();
  return ptelb;
};
CDerivee.prototype.reconstruitChaineCalcul = function() {
  this.chaineCalcul = "";
};
CDerivee.prototype.metAJour = function() {
  if (! this.fonctionAssociee.deriveePossible(0))
    this.calcul = new COp(this.listeProprietaire, new CConstante(this.listeProprietaire, 1),
        new CConstante(this.listeProprietaire, 0), Ope.Divi);
  else this.creeCalcul();
};
CDerivee.prototype.getNatureCalcul = function() {
  return NatCal.NDerivee;
};
CDerivee.prototype.dependDe = function(p) {
  if (this.elementTestePourDependDe === p) return this.dependDeElementTeste;
  return this.memoriseDependance(CFonc.prototype.dependDe.call(this,p) || this.fonctionAssociee.dependDe(p));
};
CDerivee.prototype.dependDePourBoucle = function(p) {
  return (p === this) || this.fonctionAssociee.dependDePourBoucle(p);
};
CDerivee.prototype.positionne = function() {
  this.existe = this.fonctionAssociee.existe;
};
/**
 * Fonction appelée pour les exercices de calcul et qui doit recalculer tous les éléments de la figure.
 * Donc ici il faut recalculer la formule de la dérivée
 * @returns {undefined}
 */
CDerivee.prototype.positionneFull = function() {
  this.existe = this.fonctionAssociee.existe;
  if (this.existe) {
    if (! this.fonctionAssociee.deriveePossible(0))
      this.calcul = new COp(this.listeProprietaire, new CConstante(this.listeProprietaire, 1),
          new CConstante(this.listeProprietaire, 0), Ope.Divi);
    else this.creeCalcul();
  }
};
/**
 * Calcula la dérivée et l'affecte à this.calcul
 * @returns {undefined}
 */
CDerivee.prototype.creeCalcul = function(){
  this.calcul = CalcR.creeDerivee(this.fonctionAssociee.calcul, 0);
};
CDerivee.prototype.read = function(inps, list){
  CFonc.prototype.readSansCalcul.call(this, inps, list);
  var ind1 = inps.readInt();
  this.fonctionAssociee = list.get(ind1,"CFonc");
  if (list.className !== "CPrototype") {
    if (! this.fonctionAssociee.deriveePossible(0))
      this.calcul = new COp(this.listeProprietaire, new CConstante(this.listeProprietaire, 1),
          new CConstante(this.listeProprietaire, 0), Ope.Divi);
    else this.creeCalcul();
  }
};
CDerivee.prototype.write = function(oups, list) {
  CFonc.prototype.writeSansCalcul.call(this, oups, list);
  var ind1 = list.indexOf(this.fonctionAssociee);
  oups.writeInt(ind1);
};



// WEBPACK FOOTER //
// ./src/objets/CDerivee.js